import { cn } from "src/common/utils";

const RootlyIcon = ({ className }: { className?: string }) => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={cn(className, "bg-[#9370DB] rounded-sm p-1")}
  >
    <path
      d="M7.18305 14.7294C7.18305 14.175 6.9878 13.7233 6.57675 13.3537C5.11754 12.0292 1.43866 12.0806 0.143867 12.2141L0 10.8178C0.2158 10.7972 5.29223 10.3044 7.51188 12.3065C8.22094 12.943 8.58061 13.7541 8.58061 14.7191"
      fill="white"
    />
    <path
      d="M7.41931 14.7294C7.41931 13.7643 7.77898 12.9533 8.48803 12.3167C10.7077 10.3147 15.7944 10.8075 15.9999 10.8281L15.8561 12.2141C14.5613 12.0806 10.8824 12.0293 9.42317 13.3537C9.01212 13.7233 8.81687 14.175 8.81687 14.7294"
      fill="white"
    />
    <path
      d="M13.5029 3.89799C13.5029 3.89799 11.1907 3.24092 10.3378 4.50373C9.47461 5.746 11.8176 7.49134 13.5029 3.89799Z"
      fill="white"
    />
    <path
      d="M15.0238 7.37841C15.0238 7.37841 12.8761 6.31067 11.7971 7.38868C10.7181 8.46669 12.7014 10.6124 15.0238 7.37841Z"
      fill="white"
    />
    <path
      d="M7.85098 0.941177C7.85098 0.941177 6.36094 2.81999 7.19331 4.09306C8.02568 5.36613 10.5331 3.86719 7.85098 0.941177V0.941177Z"
      fill="white"
    />
    <path
      d="M7.88184 6.19775C7.88184 6.19775 6.34041 8.0355 7.13167 9.3291C7.92294 10.6227 10.4714 9.2059 7.88184 6.19775Z"
      fill="white"
    />
    <path
      d="M2.35327 3.89799C2.35327 3.89799 4.66541 3.24092 5.51833 4.50373C6.37126 5.76653 4.03856 7.49134 2.35327 3.89799Z"
      fill="white"
    />
    <path
      d="M0.832397 7.37841C0.832397 7.37841 2.98012 6.31067 4.05912 7.38868C5.13812 8.46669 3.14454 10.6124 0.832397 7.37841Z"
      fill="white"
    />
  </svg>
);

export default RootlyIcon;
